export var ANCHOR_POSITION = {
  top: {
    x: .5,
    y: 0
  },
  "top-left": {
    x: 0,
    y: 0
  },
  "top-right": {
    x: 1,
    y: 0
  },
  bottom: {
    x: .5,
    y: 1
  },
  "bottom-left": {
    x: 0,
    y: 1
  },
  "bottom-right": {
    x: 1,
    y: 1
  },
  left: {
    x: 0,
    y: .5
  },
  right: {
    x: 1,
    y: .5
  }
};
export function getDynamicPosition(_ref) {
  var x = _ref.x,
      y = _ref.y,
      width = _ref.width,
      height = _ref.height,
      selfWidth = _ref.selfWidth,
      selfHeight = _ref.selfHeight,
      anchor = _ref.anchor,
      _ref$padding = _ref.padding,
      padding = void 0 === _ref$padding ? 0 : _ref$padding,
      _ANCHOR_POSITION$anch = ANCHOR_POSITION[anchor],
      anchorX = _ANCHOR_POSITION$anch.x,
      anchorY = _ANCHOR_POSITION$anch.y,
      top = y - anchorY * selfHeight,
      bottom = top + selfHeight,
      yStep = .5;
  if (top < padding) for (; top < padding && anchorY >= yStep;) {
    anchorY -= yStep, top += yStep * selfHeight;
  } else if (bottom > height - padding) for (; bottom > height - padding && anchorY <= 1 - yStep;) {
    anchorY += yStep, bottom -= yStep * selfHeight;
  }
  var left = x - anchorX * selfWidth,
      right = left + selfWidth,
      xStep = .5;
  if (.5 === anchorY && (anchorX = Math.floor(anchorX), xStep = 1), left < padding) for (; left < padding && anchorX >= xStep;) {
    anchorX -= xStep, left += xStep * selfWidth;
  } else if (right > width - padding) for (; right > width - padding && anchorX <= 1 - xStep;) {
    anchorX += xStep, right -= xStep * selfWidth;
  }
  return Object.keys(ANCHOR_POSITION).find(function (positionType) {
    var anchorPosition = ANCHOR_POSITION[positionType];
    return anchorPosition.x === anchorX && anchorPosition.y === anchorY;
  });
}